var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from "../Model";
import { HorizonJs_Uuid } from "horizon-js-sdk/lib/HorizonJs_Uuid";
import Product from "../Product/Product";
import GroupItem from "../Product/GroupItem";
import { PurchaseStatus } from "./PurchaseStatus";
import { PurchaseItemStatusUpdate } from "./PurchaseItemStatusUpdate";
import { PurchaseItemStockDetails } from "./PurchaseItemStockDetails";
var PurchaseItem = /** @class */ (function (_super) {
    __extends(PurchaseItem, _super);
    function PurchaseItem(obj) {
        if (obj === void 0) { obj = {}; }
        var _this = _super.call(this) || this;
        _this.uid = null;
        _this.quantity = 0;
        _this.stockDetails = null;
        /**
         * Tout purchase item canceled empêche l'ajout de
         * nouveaux purchaseItems
         */
        _this.statuses = [];
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        PurchaseItem.buildFromJson(_this, obj);
        return _this;
    }
    Object.defineProperty(PurchaseItem.prototype, "current_status", {
        get: function () {
            //TODO : regarder les status par rapport à leur date de création, pas juste par rapport à leur order.
            if (this.statuses.length > 0) {
                return this.statuses[this.statuses.length - 1];
            }
            else {
                return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    PurchaseItem.buildFromJson = function (instance, json) {
        if (json) {
            for (var prop in json) {
                if (json.hasOwnProperty(prop)) {
                    if (prop === 'statusUpdates') {
                        for (var i in json[prop]) {
                            if (json[prop].hasOwnProperty(i)) {
                                instance.statuses.push(new PurchaseItemStatusUpdate(json[prop][i]));
                            }
                        }
                    }
                    else if (prop === 'stockDetails') {
                        if (json[prop] !== null) {
                            instance[prop] = new PurchaseItemStockDetails(json[prop]);
                        }
                        else {
                            instance[prop] = null;
                        }
                    }
                    else {
                        instance[prop] = json[prop];
                    }
                }
            }
        }
    };
    PurchaseItem.prototype.isCanceled = function (status_canceled) {
        /** Si un seul status est canceled alors c'est considéré comme tel **/
        //TODO: regarder l'ordre chronologique
        for (var _i = 0, _a = this.statuses; _i < _a.length; _i++) {
            var status_1 = _a[_i];
            if (status_1.statusUid === status_canceled) {
                return true;
            }
        }
        return false;
    };
    PurchaseItem.prototype.search_uid = function (uid) {
        if (this.uid === uid) {
            return this;
        }
        else {
            for (var _i = 0, _a = this.statuses; _i < _a.length; _i++) {
                var s = _a[_i];
                var current_search = s.search_uid(uid);
                if (s.search_uid(uid) !== null) {
                    return current_search;
                }
            }
        }
        return null;
    };
    PurchaseItem.prototype.generateUid = function (allChilds) {
        if (allChilds === void 0) { allChilds = false; }
        if (this.uid === null) {
            this.uid = HorizonJs_Uuid.v4();
        }
        if (allChilds) {
            for (var _i = 0, _a = this.statuses; _i < _a.length; _i++) {
                var status_2 = _a[_i];
                status_2.generateUid(allChilds);
            }
        }
    };
    PurchaseItem.prototype.exportToJson = function () {
        var JSONPurchase = {};
        JSONPurchase.uid = this.uid;
        JSONPurchase.quantity = this.quantity;
        JSONPurchase.stockDetails = this.stockDetails ? this.stockDetails.exportToJson() : null;
        if (this.reference) {
            JSONPurchase.reference = this.reference;
        }
        if (this.statuses.length !== 0) {
            JSONPurchase.statusUpdates = [];
            for (var _i = 0, _a = this.statuses; _i < _a.length; _i++) {
                var item = _a[_i];
                JSONPurchase.statusUpdates.push(item.exportToJson());
            }
        }
        return JSONPurchase;
    };
    PurchaseItem.prototype.is_same_status_as_current = function (statusUid) {
        if (this.current_status !== null) {
            if (this.current_status.statusUid === statusUid) {
                return {
                    isOk: true
                };
            }
        }
        return {
            isOk: false
        };
    };
    PurchaseItem.prototype.is_status_allowed = function (statusUid, options) {
        if (this.current_status !== null) {
            /** Sinon on fait le fait la vérification **/
            for (var _i = 0, _a = options.flow; _i < _a.length; _i++) {
                var flow_status = _a[_i];
                if (flow_status.uid === this.current_status.statusUid) {
                    for (var _b = 0, _c = flow_status.nextStatuses; _b < _c.length; _b++) {
                        var next_status = _c[_b];
                        if (next_status.statusUid === statusUid) {
                            return { isOk: true };
                        }
                    }
                }
            }
            if (options.debug) {
                console.warn("Le status actuel n'autorise pas le status voulant être ajouté.\n", "File : Purchase.ts\n", "Object : PurchaseItem\n", "Function : is_status_allowed()\n", "Status actuel : " + this.current_status.statusUid + "\n", "Status voulant être ajouté : " + statusUid + "\n");
            }
            return {
                isOk: false,
                reason: [{
                        currentStatus: this.current_status,
                        statusUid: statusUid,
                        reason: "Le status actuel n'autorise pas le status voulant être ajouté."
                    }]
            };
        }
        else {
            //On verifie si ça peut être le status initial
            if (options.initialStatus !== undefined && statusUid === options.initialStatus) {
                return { isOk: true };
            }
            else {
                if (options.debug) {
                    console.warn("Il n'y a pas de status actuellement et vous essayez d'ajouter un status non-initial.\n", "File : Purchase.ts\n", "Object : PurchaseItem\n", "Function : is_status_allowed()\n", "Status actuel : " + this.current_status + "\n", "Status voulant être ajouté : " + statusUid + "\n", "Status initial : " + options.initialStatus + "\n");
                }
                return {
                    isOk: false,
                    reason: [{
                            currentStatus: this.current_status,
                            statusUid: statusUid,
                            reason: "Il n'y a pas de status et vous essayez d'ajouter un status qui n'est pas initial."
                        }]
                };
            }
        }
    };
    PurchaseItem.prototype.add_status = function (statusUid, options) {
        //Le status est-il autorisé.
        var is_next_status_authorized = this.is_status_allowed(statusUid, {
            flow: options.flow,
            initialStatus: options.initialStatus
        });
        if (is_next_status_authorized.isOk) {
            /** Si le status voulant être ajouté est le status initial
             * ET que l'on est toujours en status initial
             * ET qu'il n'y a pas d'actions liés à ce status
             * **/
            var purchaseItemStatusUpdate = new PurchaseItemStatusUpdate();
            purchaseItemStatusUpdate.statusUid = statusUid;
            this.statuses.push(purchaseItemStatusUpdate);
            /** On execute les actions potentielles **/
            if (!options.dryRun) {
                this.execute_status_actions(statusUid, options);
            }
            /** Si tout est ok on renvoie ok **/
            return { isOk: true };
        }
        else {
            return is_next_status_authorized;
        }
    };
    PurchaseItem.prototype.execute_status_actions = function (statusUid, options) {
        var status = PurchaseStatus.getCorrespondingStatus(statusUid, options.flow);
        if (status !== null) {
            for (var _i = 0, _a = status.actions; _i < _a.length; _i++) {
                var action = _a[_i];
                if (options.productOrGroupItem instanceof Product) {
                    if (action === "DECREASE_STOCK") {
                        if (options.productOrGroupItem.stock) {
                            options.productOrGroupItem.stock.currentQty -= this.quantity;
                        }
                    }
                    if (action === "PUT_BACK_IN_STOCK") {
                        if (options.productOrGroupItem.stock) {
                            options.productOrGroupItem.stock.currentQty += this.quantity;
                        }
                    }
                }
                else if (options.productOrGroupItem instanceof GroupItem) {
                    if (options.productOrGroupItem.productUid !== null) {
                        var product = Product.getCorrespondingProduct(options.productOrGroupItem.productUid, options.products);
                        if (product !== null) {
                            if (action === "DECREASE_STOCK") {
                                if (product.stock) {
                                    product.stock.currentQty -= this.quantity;
                                }
                            }
                            if (action === "PUT_BACK_IN_STOCK") {
                                if (product.stock) {
                                    product.stock.currentQty += this.quantity;
                                }
                            }
                        }
                    }
                }
            }
        }
        return { isOk: true };
    };
    return PurchaseItem;
}(Model));
export { PurchaseItem };
//# sourceMappingURL=PurchaseItem.js.map